<template>
  <div style="height: 100%">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <span style="color: #4a90e2">
            <i class="el-icon-location"></i>
            {{ $t('map.首页') }}
          </span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('map.地图') }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="block" style="margin-top: 12px">
        <el-date-picker v-model="dbt" type="date" :placeholder="$t('map.开始日期')" value-format="yyyy-MM-dd"></el-date-picker>
        {{ $t('map.至') }}
        <el-date-picker v-model="edt" type="date" :placeholder="$t('map.结束日期')" value-format="yyyy-MM-dd" @change="equiphistory"></el-date-picker>
        <el-button type="primary" style="margin-left: 10px" @click="equiphistory">{{ $t('map.确定') }}</el-button>
        <!-- {{ $t('map.显示卫星图') }} -->
        <!-- <van-switch size="16px" @change="onSwitchChange" v-model="checked" /> -->
        <el-select
          style="margin-left: 10px;"
          class="select-box"
          @change="selecttype(method)"
          :no-data-text="$t('home.noData')"
          v-model="method"
          placeholder="切换图源"
        >
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <div id="container" style="width: 100%; height: 90%"></div>
    <!-- <div ref="mapContainer" id="mapContainer" style="height: 400px;"></div> -->
  </div>
</template>

<script>
import { getToken } from '../utils/auth'
import { equiphistory, equipinfo } from '../service/getData'
import moment from 'moment'
import { Switch } from 'vant'
// import { Loader } from '@googlemaps/js-api-loader';
// 信息窗
var infoWindow = null
// 折线
var polyline = null
function markerClick(e, _this) {
  infoWindow.setContent(e.target.content)
  infoWindow.open(_this.map, e.target.getPosition())
}
// 本地服务器卫星
//     <script async defer src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDoUXB2kTf7I2osZYdKLISoZ5gsGGiPk-c&callback=initMap">
// return `http://140.249.20.207:8081/map/shiLiang/${z}/${x}/${y}.png`
var satelliteLayer = new AMap.TileLayer.Satellite()
// 英文
var googleLayer2 = new AMap.TileLayer({
  getTileUrl: function(x, y, z) {
    return `http://mt0.google.com/vt/lyrs=p&hl=en&x=${x}&y=${y}&z=${z} `
  }
})
//中文
var googleLayer = new AMap.TileLayer({
  getTileUrl: function(x, y, z) {
    // return `http://mt${x % 4}.google.com/vt/lyrs=m@142&hl=zh-CN&gl=cn&x=${x}&y=${y}&z=${z}&s=Galil`
    return `http://mt0.google.com/vt/lyrs=p&hl=en&x=${x}&y=${y}&z=${z} ` //英文
  },
  zIndex: 2
})
// new AMap.TileLayer.Satellite()

export default {
  components: {
    [Switch.name]: Switch
  },
  name: 'app',
  data() {
    return {
      map: null,
      markers: [],
      checked: localStorage.getItem('layer') ? JSON.parse(localStorage.getItem('layer')) : true,
      tp: null,
      info: null,
      deviceList: null,
      listPoint: null,
      // 开始时间
      dbt:
        null ||
        moment()
          .subtract(1, 'months')
          .format('YYYY-MM-DD'),
      // 结束时间
      edt: null || moment().format('YYYY-MM-DD'),
      // 路由来的params/设备ID
      equipid: this.$route.params.mapId,
      method: null,
      options: [
        {
          label: '谷歌地图',
          value: 2
        },
        {
          label: '显示卫星图',
          value: 1
        },
        {
          label: '高德地图',
          value: 3
        }
      ],
      // 英文
      optionsen: [
        {
          label: 'GoogleMap',
          value: 2
        },
        {
          label: 'Show Satellite Map',
          value: 1
        },
        {
          label: 'China Gaode Map',
          value: 3
        }
      ],
      optionszh: [
        {
          label: '谷歌地图',
          value: 2
        },
        {
          label: '显示卫星图',
          value: 1
        },
        {
          label: '高德地图',
          value: 3
        }
      ],
      mapContainer: null,
      loader: null
    }
  },
  methods: {
    onSwitchChange(checked) {
      localStorage.setItem('layer', JSON.stringify(checked))
      if (checked) {
        this.map.add(googleLayer)
      } else {
        this.map.remove(googleLayer)
      }
    },
    selecttype(method) {
      console.log(googleLayer, googleLayer2)
      if (method == '2') {
        localStorage.setItem('layer', JSON.stringify(method))
        location.reload()
      } else if (method == '1') {
        localStorage.setItem('layer', JSON.stringify(method))
        location.reload()
      } else if (method == '3') {
        localStorage.setItem('layer', JSON.stringify(method))
        location.reload()
      }
    },
    // 标记点
    addMarker(point, i) {
      let marker = new AMap.Marker({
        icon: '/static/point.png',
        position: point,
        offset: new AMap.Pixel(0, 0)
      })
      let equipname = this.info.enm
      let contentHTML = `<div>${this.$t('map.设备名称')}：${equipname}</div><div>${this.$t('map.经纬度')} ${this.deviceList[i]['jdt']},${
        this.deviceList[i]['wdt']
      }</div>`
      this.tp.map((n, index) => {
        let no = index
        contentHTML += `<div>${this.$t(`map.${n.tnm}`)}：${this.deviceList[i]['col' + no]}</div>`
      })
      contentHTML = contentHTML + `<div>${this.$t('map.时间')}${this.deviceList[i]['createtime']}</div>`
      marker.content = contentHTML
      marker.on('click', e => markerClick(e, this))
      // marker.emit('click', {
      //   target: marker
      // })
      this.markers.push(marker)
    },
    async equiphistory() {
      infoWindow && infoWindow.close()
      // 清除marker
      if (this.map) {
        this.map.remove(polyline)
        this.map.remove(this.markers)
        this.markers = []
      }
      this.equipid = this.$route.params.mapId
      let loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let tp = await equipinfo(this.equipid)
      this.tp = tp.data.tp
      this.info = tp.data

      let result = await equiphistory(this.dbt, this.edt, this.equipid, 1, 99999)

      loading.close()
      this.deviceList = result.data.total ? JSON.parse(result.data.data) : []
      if (!this.deviceList || this.deviceList.length === 0) {
        infoWindow.close()
      }
      this.listPoint = [] //列表的坐标点

      this.deviceList = this.deviceList.filter(item => {
        if (+item.jd === 1 || +item.jd === 0 || +item.wd === 1 || +item.wd === 0) {
          return false
        } else {
          return true
        }
      })
      this.deviceList.map(item => {
        let arr = []
        arr.push(`${(item.jdchar === 'W' && '-') || ''}${item.jd}`)
        arr.push(`${(item.wdchar === 'S' && '-') || ''}${item.wd}`)

        let LngLat, jd, wd
        jd = item.jd
        wd = item.wd
        if (item.jdchar === 'W') {
          jd = 360 - item.jd
        }
        if (item.wdchar === 'S') {
          wd = -item.wd
        }
        LngLat = new AMap.LngLat(jd, wd, true)
        // 添加折线路径
        this.listPoint.push(LngLat)
      })

      this.map =
        this.map ||
        new AMap.Map('container', {
          zooms: [3, 18],
          resizeEnable: true,
          features: ['bg', 'road', 'building', 'point'],
          expandZoomRange: true
        })
      let layer = JSON.parse(localStorage.getItem('layer'))
      console.log(layer, this.map.add([satelliteLayer]), satelliteLayer, '111111')
      if (layer == '1' || layer === null) {
        this.map.remove([googleLayer])
        this.map.add([satelliteLayer])
      } else if (layer == '2' || layer === null) {
        this.map.remove([satelliteLayer])
        this.map.add([googleLayer])
      } else {
        this.map.remove(googleLayer)
        this.map.remove([satelliteLayer])
      }

      // 创建折线实例
      polyline = new AMap.Polyline({
        path: this.listPoint,
        borderWeight: 1, // 线条宽度，默认为 1
        strokeColor: 'white', // 线条颜色
        lineJoin: 'round' // 折线拐点连接处样式
      })
      // 将折线添加至地图实例
      this.map.add(polyline)
      this.listPoint.map((point, index) => {
        this.addMarker(point, index)
      })

      this.map.add(this.markers)
      this.map.setFitView()
      this.map.setZoom(10)

      this.listPoint && this.listPoint.length > 0 && this.map.setCenter(this.listPoint[this.listPoint.length - 1])

      this.markers &&
        this.markers.length > 0 &&
        this.markers[this.markers.length - 1].emit('click', {
          target: this.markers[this.markers.length - 1]
        })
    },
    initmap() {
      // this.mapContainer = this.$refs.mapContainer
      // // 使用你的 Google Maps API 密钥
      // this.loader = new Loader({
      //   apiKey: 'AIzaSyDoUXB2kTf7I2osZYdKLISoZ5gsGGiPk-c'
      //   // version: 'weekly', // 或者具体的版本号，如 '3.46'
      // })
      // // 加载 Google Maps API
      // this.loader.load().then(async () => {
      //   // 创建地图
      //   this.map = new window.google.maps.Map(this.mapContainer, {
      //     center: { lat: 37.7749, lng: -122.4194 }, // 地图中心坐标
      //     zoom: 12 // 缩放级别
      //     // resizeEnable: true,
      //     // features: ['bg', 'road', 'building', 'point'],
      //     // expandZoomRange: true,
      //   })
      //   // 添加其他地图功能或标记等
      // })
    }
  },
  watch: {
    // 监听map页面路由变化
    async $route() {
      infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, 0)
      })
      await this.equiphistory()
    }
  },
  created() {
    if (this.$i18n.locale == 'zh') {
      this.options = this.optionszh
    } else {
      this.options = this.optionsen
    }
    this.lang = localStorage.getItem('lang') || 'zh'
    if (JSON.parse(localStorage.getItem('layer')) != null) {
      this.method = JSON.parse(localStorage.getItem('layer'))
    } else {
      if (this.lang == 'zh') {
        this.method = 3
        localStorage.setItem('layer', JSON.stringify(this.method))
      } else {
        this.method = 2
        localStorage.setItem('layer', JSON.stringify(this.method))
      }
    }

    console.log('111111', this.method)
  },
  mounted() {
    if (!getToken()) {
      this.$router.push('/login')
      return
    }

    setTimeout(async () => {
      infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, 0)
      })
      await this.equiphistory()
    }, 500)
  }
}
</script>
<style lang="scss" scoped>
#map {
  background: white;
  height: 90%;
}
</style>
<style>
.amap-marker-label {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-size: 16px;
  background: #3e95fa;
  color: white;
}
.amap-info-content {
  max-height: 400px;
}
</style>
